import { types } from '../types/typesContacts';

const initialState = {
    listAllContacts: [],
    listCustomers: [],
    listSuppliers: [],
    listExcutives: [],
    listaPersonas: []
}

export const contactsReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.contactsGetAllContacts:
            return {
                ...state,
                listAllContacts: [...action.payload]
            }

        case types.contactsGetListCustomers:
            return {
                ...state,
                listCustomers: [...action.payload]
            }

        case types.contactsGetListSuppliers:
            return {
                ...state,
                listSuppliers: [...action.payload]
            }

        case types.contactsAddNewSupplier:
            return {
                ...state,
                listSuppliers: [...state.listSuppliers, action.payload]
            }

        case types.contactsAddNewCustomer:
            return {
                ...state,
                listCustomers: [...state.listCustomers, action.payload]
            }

        case types.contactsGetListPersonas:
            return {
                ...state,
                listaPersonas: [...action.payload]
            }

        default:
            return state;
    }

}
